module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    key: _vm.index,
    staticClass: "product_list",
    style: (_vm.bgcolor)
  }, [_c('h3', [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('span', {
    staticClass: "product_note"
  }, [_vm._v(_vm._s(_vm.item.note[0]))]), _vm._v(" "), _c('span', {
    staticClass: "product_note"
  }, [_vm._v(_vm._s(_vm.item.note[1]))]), _vm._v(" "), _c('play-img', {
    attrs: {
      "isLink": false,
      "images": _vm.item.images,
      "size": _vm.size
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "color-text"
  }, [_vm._v(_vm._s(_vm.item.ad))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a3885cae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/List.vue
// module id = 187
// module chunks = 1